import { jsx as t } from "react/jsx-runtime";

import { memo as e } from "react";

import o from "@ui-components-3/icons/lib/regular/CircleInfo";

import r from "../Tooltip/index.js";

import i from "../../utils/classNames/index.js";

const a = e((({children: e, className: a, as: n, tooltipBeforeLabel: l = !1, tooltipContent: s, ...m}) => {
    const c = s && t(r, {
        content: s,
        placement: l ? "left-start" : "right-start",
        children: t("button", {
            type: "button",
            "aria-label": "string" == typeof e ? `More information about ${e}` : "More information",
            className: "btn-unsized btn-primary-borderless align-text-bottom",
            children: t(o, {
                className: "h-[1em] w-[1em]",
                "aria-hidden": "true"
            })
        })
    }, "t");
    return t(n || "label", {
        ...m,
        className: i("typography-body font-medium leading-tight", a),
        children: c ? l ? [ c, "  ", e ] : [ e, "  ", c ] : e
    });
}));

export { a as default };
//# sourceMappingURL=index.js.map
